import { getRiskScoreColor } from "@/utils/risk-calculator";
import { cn } from "@/lib/utils";

interface RiskScoreCellProps {
  score: number;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function RiskScoreCell({
  score,
  size = "md",
  className,
}: RiskScoreCellProps) {
  const colorClass = getRiskScoreColor(score);

  const sizeClasses = {
    sm: "text-lg px-2 py-1",
    md: "text-2xl px-3 py-2",
    lg: "text-4xl px-4 py-3",
  };

  return (
    <div
      className={cn(
        "rounded-lg font-bold text-center transition-colors",
        colorClass,
        sizeClasses[size],
        className
      )}
    >
      {score.toFixed(1)}
    </div>
  );
}
